import React, {useEffect, useRef, useState} from 'react';
import {createTable} from "./simplexion-table";
import {filterTable} from "./table-filter";
import {useTranslation} from "react-i18next";
import LinearProgress from "@material-ui/core/LinearProgress";
import {handleResize} from "./resize";


const createColumn = (col, t, nameSpace) => {
    const {accessor, sortable, renderer, headerRenderer} = col;

    let header = col.header;

    if (!col.header) {
        header = t(nameSpace + ':' + accessor);
    }

    return {
        accessor: accessor,
        header: header,
        sortable: sortable,
        renderer: renderer,
        headerRender: headerRenderer,
    }
};

export const SimplexionTable = ({tableConfig, data, loadingStatus, filterValue}) => {
    const {t} = useTranslation();

    const [counter, setCounter] = useState(20);

    tableConfig.columns = tableConfig.columns.map(col => createColumn(col, t, tableConfig.nameSpace));

    if (!data) data = [];

    const classes = tableConfig.styles || {};

    const tableStorage = useRef({
        data: data,
        tableConfig: tableConfig,
        rows: {},
        filterValue: filterValue,
    });

    // Creates the table when the component mounts
    useEffect(() => {
        tableStorage.current.data = data;
        createTable(tableStorage.current);
    }, [data]);

    // Adds the event listener necessary for sticky headers and removes it in it's cleanup
    useEffect(() => {

        const tableId = tableConfig.id;

        const resizeCallback = () => handleResize(tableId);

        if (tableConfig.stickyHeader) window.addEventListener('resize', resizeCallback);

        handleResize(tableId)

        return () => window.removeEventListener('resize', resizeCallback);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Runs filter on the table when the props.filterValue changes
    useEffect(() => {
        if (filterValue === undefined) return;
        tableStorage.current.filterValue = filterValue;
        filterTable(tableStorage.current);

    }, [filterValue]);

    const tableBody = document.getElementById(tableConfig.id + "-tbody");

    useEffect(() => {
        if ((loadingStatus === 0) && tableBody && tableBody.children && (tableBody.children.length === data.length)) {
            setCounter(100)
        } else if ((loadingStatus === 0) && tableBody && tableBody.children && (tableBody.children.length === 0)) {
            setCounter(90)
        } else {
            setCounter(40)
        }
    }, [tableBody, loadingStatus, data]);

    return (
        <div style={{overflowX: 'auto'}}>
            <div id={`main-wrapper-${tableConfig.id}`} className={classes.stWrapper}>
                {(loadingStatus === 0) && (counter < 100) ?
                    <LinearProgress variant="buffer" value={counter}
                                    valueBuffer={((counter + 15) < 100) ? counter + 15 : 100}
                                    color="secondary"/> : null}
                {tableConfig.stickyHeader &&
                <div id={`sticky-header-${tableConfig.id}`} className={classes.stStickyHeaderWrapper}/>}
                <div id={`simplexion-table-${tableConfig.id}`} className={classes.stTableWrapper}/>
            </div>
        </div>
    );
};
